module.exports = __webpack_public_path__ + "static/media/hihat.4ba39e07.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/hihat.wav
// module id = 61
// module chunks = 0